import { useQuery } from "@tanstack/react-query";
import { getAirports  } from "../../apiNew";
import { Airport } from "../../../models/airports";

const useGetAirports = (
  airportCode: string | null | undefined,
): { data: Airport[]; isFetching: boolean; isError: boolean } => {
  const { data, isFetching, isError } = useQuery({
    queryKey: ['airports', airportCode],
    queryFn: () => getAirports(airportCode),
    enabled: !!airportCode,
    refetchOnWindowFocus: false,
  });

  return { data, isFetching, isError };
};

export default useGetAirports;
